module.exports = {
	message: {
		home: {
			language: "English",
			keyword:'Keyword',
			hotPro:'HOT-SELLING PRODUCTS',
			product:'MAIN PRODUCTS',
			about:'ABOUT US',
			aboutDesc:'customer service, customer satisfaction',
			news:'LATEST NEWS',
			company:'COMPANY',
			proVideo:'PROMOTIONAL VIDEO',
			certificate:'CERTIFICATE',
			factory:'COOPERATIVE FACTORY'
		},
		about:{
			advantages:'OUR ADVANTAGES',
			factory:'FACTORY DISPLAY',
			honors:'Honors & Certificates',
			honorsDesc:'We pursues its goal of serving you better',
			title1:'Production Capacity',
			content1:'Fully owned,huge,modern production plant',
			title2:'Competitive Price',
			content2:'Reasonable price,high cost performance',
			title3:'Prompt Delivery',
			content3:'Several warehouses located in the main loading port',
			title4:'Professional Team',
			content4:'Professional developing, producing,exporting team',
			free1:'Customized Services',
			frcon1:'Metal recycling refers to the physical or mechanical processing of useful materials separated from scrap metals into recycled products. It is an industrial chain from recycling, disassembly to recycling. The metal recycling industry has formed a complete industrial chain and recycling ecosystem. As emerging economies gradually adopt technologies and lifestyles similar to those of OECD countries, the global demand for metals in the future will reach 3 to 9 times the amount of metals used worldwide. Recycling complex metal products can solve and cope with the challenges brought about by the surge in metal demand.',
			free2:'Quality Control',
			frcon2:'Metal recycling equipment mainly includes crushing and pulverizing equipment, sorting equipment, pretreatment equipment and regeneration processing equipment, etc. Different equipment plays a key role in different links of metal recycling. These equipment are widely used to process scrap metal and improve resource utilization, covering a variety of technical means such as physical crushing, magnetic separation, flattening, etc.',
			free3:'One-stop Logistics',
			frcon3:'Our company‘s factory metal recycling center specializes in handling all kinds of metal waste and is committed to the recycling and refining of rare metals. The in-store recycling range covers the world, providing convenient services such as on-the-spot price analysis and cash transactions. Our company focuses on high-content (90%) metal waste, which can be recycled regardless of weight or shape.',
			free4:'Third-party Inspection',
			frcon4:'In addition to the environmental impact of metal mining and smelting, it also consumes 7% to 8% of the world’s energy supply. Recycling consumes less energy than primary production of metals, while reducing the overall impact on the mining sites. Metal recycling can also reduce the demand for low-grade ores, avoiding the mining of some precious metals that will be scarce in the future.',
			new1:'News',
			new2:'Company News',
			new3:'Industry News'
		},
		service:{
			ourservice:'Our Services',
			questions:'FREQUENTLY ASKED QUESTIONS',
			message:'Leave A Message',
			hours:'Please feel free to leave a message. We will reply you in 24 hours.',
			name:'Your Name:',
			mail:'E-Mail:*',
			tel:'Tel / Whatsapp：',
			type:'Product Type:*',
			video:'VIDEO',
			up:'Previous page',
			next:'Next page'
		},
		contact:{
			help:'WE’RE HERE TO HELP',
			helpDesc:'Contact us through the following contact information',
			manager:'Sales Manager',
			phone:'Phone / Whatsapp / Wechat',
			sendeamil:'send Email',
			ouraddress:'Our Address'
		}, 
		foot:{
			navigation:'Quick Navigation',
			type:'Categories',
			mobile:'MOBILE(WHATSAPP/WECHAT)',
			email:'Email',
			address:'Address',
			number:'Filing Number',
			service:'One Stop Service, Selection Easier'
		},
		product:{
			description:'DESCRIPTION',
			technical:'TECHNICAL SPECIFICATIONS',
			advantages:'ADVANTAGES',
			related:'RELATED PRODUCTS',
			videoDesc:'The Source Factory Of Ferroalloy In China. Best quality! Lowest price! Agent Available! High Commission!',
			ti1:'Please fill in the email address.',
			ti2:'Please fill in the type.',
			ti3:'Please fill in the content.',
			menu1:'Description',
			menu2:'Technical Specifications',
			menu3:'Advantage',
			menu4:'FAQ'
		},
		nav:{
			home:'Home',
			about:'About Us',
			products:'Products',
			news:'News',
			video:'Video',
			free:'Recycle & Free Tech',
			contact:'Contact Us',
			vr:'VR',
			chat:'Chat',
			whatsapp:'Whatsapp',
			wechat:'Wechat',
			message:'Message',
			tel:'Tel',
			top:'Top',
		},
		btn:{
			read:'READ MORE',
			news:'MORE NEWS',
			exhibition:'MORE INFORMATION',
			watchVideo:'WATCH MORE VIDEOS',
			services:'Services',
			products:'Products',
			contactus:'Contact Us',
			inquiry:'INQUIRY NOW',
			size:'Size',
			packing:'Packing',
			service:'Online Service',
			submit:'SUBMIT',
			sendEmial:'SEND EMAIL',
			now:'ORDER NOW',
			text1:'Don’t Hesitate To contact Us Any Time.',
			text2:'We design the content and granularity of the materials that meet your needs.',
			text3:'Whether you need to increase safety, maximize production capacity or reliability, or reduce costs, we deliver.',
			text4:'We are dedicated to providing exceptional customer service and delivering high-quality products to our valued clients.',
			text5:'Focus on High-Quality Ferro Silicon and Silicon Metal Production',
			text6:'* Tips: 1.What Product Do You Need? 2.What Project Do You Plan To Do? 3.When Will You Need This Product?'
		}
    }
};
